module.exports = __webpack_public_path__ + "img/file.f5540c43.png";